<template lang='pug'>
  .meeting-form(:class="{ 'width-flow': send_to_new_flow }")
    .meeting-form_header 
      strong Reunião
      br
      | {{ task.contact.full_name }} - {{ task.contact.business.name }}
    .clear
    div.flow-form__lost-selects
      form.row
        .div.col-md(:class="{ 'col-md-12': !send_to_new_flow, 'col-md-5': send_to_new_flow }")
          .form-group
            label Status da reunião
            select.form-control(v-model='status', name='status')
              option(v-for='status in statuses', :value='status.value') {{ status.label }}

          .form-group(:class="{ 'has-error' : errors.has('lost_reason_unit') }" v-if="is_status_lost")
            label Motivo de Perda
            dropdown-select.field(v-model='lost_reason_id',
                                  data-vv-name='lost_reason_unit',
                                  :v-validate="lost_reason_validate",
                                  :options='lostReasonOptions()')
            transition-group(name='fade')
              .help-block(v-show="errors.has('lost_reason_unit')", key="lost_reason_unit") Favor selecionar o motivo de perda

          .form-group(v-if="!is_status_connect")
            label Comentário:
            textarea.form-control(v-model='comment')

          .form-group
            .toggler-inline(@click='toggleType()')
              input(type='checkbox' :checked='send_to_new_flow')
              label Enviar para novo fluxo?

          .form-group
            .toggler-inline(@click='toggleNewMeeting()')
              input(type='checkbox' :checked='new_meeting')
              label Cria nova reunião?

        div(v-if="send_to_new_flow").line-vertical
        .div.col-md(v-if="send_to_new_flow"
            :class="{ 'col-md-7': send_to_new_flow }")
            
          .form-group.contact-list-item-flow(:class="{ 'has-error' : !flow && send_to_new_flow }")
            label Buscar por nome do fluxo
            flows.field(@flow-selected="selectFlow",
              :user_id="selected_user"
              :default_flow="default_flow")
            transition-group(name='fade')
              .help-block(v-show="!flow && send_to_new_flow", key="flow_error") Favor selecionar o novo fluxo

          .form-group
            label Selecione um período para reativação
              div
                span(v-for="period in reactivation_period_options")
                  button(type="button"
                        class="button-reactivation-period"
                        v-bind:class="{'selected': period.days == reactivation_period}"
                        @click="setReactivationPeriod(period.days)") {{ period.label }}

          .form-group
            label Data Customizada:
            .row
              .col-md-3.no-padding
                input.form-control(type='text',
                                  name='due_on_date'
                                  placeholder='DD/MM/AAAA'
                                  v-mask='"##/##/####"'
                                  v-validate="'required|regex:^([0-3][0-9]/[0-1][0-9]/[0-3][0-9][0-9][0-9])$'"
                                  v-model='due_on_date')
              .col-md-9.calendar-right-align
                datepicker(:inline='true',
                          :disabled='{ to: yesterday }',
                          language='pt-br',
                          v-model='due_on_date_custom')

    hr
    .meeting-form_footer
      .btn.btn-default(@click='$emit("close-meeting-modal")') Cancelar
      .btn.btn-primary(@click='submit') Salvar
</template>

<script>
const helpers = require("../../../helpers.coffee");

const view_model = {
  props: ["task"],
  components: {
    flows: require("../autocomplete/flows.vue")
  },
  data() {
    return {
      lost_reason_id: null,
      comment: "",
      send_to_new_flow: false,
      reactivation_period: 0,
      due_on_date_custom: new Date(),
      due_on_date: "",
      reactivation_period_options: [
        { label: "Imediatamente", days: 0 },
        { label: "Amanhã", days: 1 },
        { label: "Em 3 dias", days: 3 },
        { label: "Em 1 semana", days: 7 },
        { label: "Em 2 semana", days: 14 },
        { label: "Em 1 mês", days: 30 },
        { label: "Em 3 meses", days: 90 },
        { label: "Em 6 meses", days: 180 }
      ],
      statuses: [
        { value: "connect", label: "Conectado" },
        { value: "lost", label: "Perdido" },
        { value: "no-show", label: "No Show" }
      ],
      status: 'connect',
      flow: null,
      flow_resource: null,
      immediately: true,
      due_on_time: "00:01",
      selected_user: Session.current_user.id,
      new_meeting: false,
      default_flow: Session.current_user.flow.id ? Session.current_user.flow : null
    };
  },

  methods: {
    submit() {
      this.$validator.validateAll().then(success => {
        if (!this.flow && this.send_to_new_flow) {
          return;
        }
        this.task.markAsDone()
        if (success) {
          let params = {
            id: this.task.id,
            lost_reason_id: this.lost_reason_id,
            lost_reason_comment: this.comment,
            send_to_new_flow: this.send_to_new_flow,
            flow: this.flow,
            due_on_date_custom: moment(this.due_on_date_custom).format('YYYY-MM-DD') + 'T' + this.due_on_time,
            immediately: this.immediately,
            status: this.status,
            done_at: this.task.done_at
          }

          new TasksResource().update(this.updateSuccess, this.updateError, params)

          if(this.new_meeting) {
            EventsBus.$emit('TaskModalForm::Show', { task_id: null, contact: this.task.contact, id: 'manual-task-form-modal' })
          }

          this.$emit("close-meeting-modal")
        }
      });
    },

    updateSuccess(response) {
      Loader.off()
      alertify.success('Tarefa atualizada com sucesso')
      response.task.assigned_to = this.task.assigned_to
      this.$emit('task-updated', response.task)
    },

    updateError(response) {
      Loader.off()
      alertify.error("Ops, algo deu errado!")
    },

    lostReasonOptions() {
      var result = [];
      result.push({ value: null, text: "Selecione um motivo de perda" });
      if (this.$store.getters.lostReasonsCount == 0) {
        this.$store.dispatch("fetchLostReasons");
      }
      var list = this.$store.getters.lostReasonsList;
      var index;
      for (index = 0; index < this.$store.getters.lostReasonsCount; index++) {
        result.push({ value: list[index].id, text: list[index].title });
      }
      return result;
    },
    toggleType() {
      this.send_to_new_flow = !this.send_to_new_flow;
    },
    toggleNewMeeting() {
      this.new_meeting = !this.new_meeting;
    },
    setReactivationPeriod(days) {
      this.reactivation_period = days;
      days == 0 ? (this.immediately = true) : (this.immediately = false);
      this.due_on_date_custom = moment()
        .add(days, "days")
        .toDate();
    },
    selectFlow(flow) {
      this.flow = flow.id;
    },
    formatDueOnDate(date) {
      this.due_on_date = moment(date).format("DD/MM/YYYY");
      var today = moment({ hours: 0 });
      this.reactivation_period = moment(date).diff(today, "days");
      this.reactivation_period == 0 ? this.immediately = true : this.immediately = false;
    }
  },
  created() {
    this.formatDueOnDate(new Date());
    this.selected_user = this.contact.user.id
  },
  computed: {
    yesterday() {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    flow_immediately() {
      return (
        "Enviar para novo fluxo " +
        (this.immediately ? "imediatamente" : "agendado")
      );
    },
    is_status_connect () {
      return(this.status === 'connect' || this.status === 'no-show')
    },

    is_status_lost () {
      return(this.status === 'lost')
    },

    lost_reason_validate() {
      if(this.status === 'lost') {
        return("'required'")
      } else {
        return('')
      }
    }
  },
  watch: {
    due_on_date_custom: function() {
      this.formatDueOnDate(this.due_on_date_custom);
      this.immediately = false;
    },
    due_on_date: function() {
      if (this.due_on_date.length == 10) {
        var date = new Date();
        date.setDate(date.getDate() - 1);
        if (moment(this.due_on_date, "DD/MM/YYYY").toDate() < date)
          return alertify.error(
            "A data de ativação deve ser maior que a data atual!"
          );
        this.due_on_date_custom = moment(
          this.due_on_date,
          "DD/MM/YYYY"
        ).toDate();
        this.immediately = false;
      }
    }
  }
};

exports.default = helpers.vue_include(view_model);
</script>

<style lang='sass'>
@import "../../../assets/stylesheets/_variables.sass"
.meeting-form
  position: absolute
  background-color: white
  padding: 20px
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175)
  border: 1px solid rgba(0, 0, 0, 0.15)
  border-radius: 5px
  z-index: 10
  width: 400px
  margin: auto

  form
    width: 100%

    textarea
      height: 200px

  .meeting-form_header
    background-color: #1B4B74
    color: white
    margin: -20px -20px 20px -20px
    padding: 20px 20px 15px 20px
    border-radius: 5px 5px 0 0

  .meeting-form_footer
    text-align: center
    .btn-default
      margin-right: 10px
      background-color: gray
      color: white

  .row
    margin: 0px

  .button-reactivation-period
    margin: 4px
    background-color: white
    border: 1px solid gray
    border-radius: 2px
    padding: 8px
    outline: none

  .button-reactivation-period.selected
    border: 1px solid $reev-base-green
    color: $reev-base-green

  .flow-list
    line-height: 20px

  .contact-stage
    font-size: 12px

  .line-vertical
    border-left: 1px solid #cccccc45
    height: 480px
    position: absolute
    left: 42%

  .no-padding
    padding-left: 0px
    padding-right: 0px

  .calendar-right-align
    padding-left: 25px
    padding-right: 0px

  .col-md
    padding-left: 25px
    padding-right: 25px

  .v-autocomplete
    position: relative
    width: 100%
  .v-autocomplete-input-group
    margin-bottom: 0 !important
    width: 100%
  .contact-list-item-flow,
  .v-autocomplete-input-group
    margin-bottom: 30px
    .toggler-inline
      width: 100%
      display: flex
      flex-direction: row
      align-items: center;
    input[type=search]
      flex: 8
      height: 30px;
      border-radius: 3px;
      border: solid 1px #c4cacf
      padding-left: 8px
      width: 100% !important
    label
      margin-right: 14px
    .v-autocomplete-list
      z-index: 200
      position: absolute
      width: 100%
      text-align: left
      border-radius: 2px
      background-color: #ffffff
      border: solid 1px #e6e8ea
      margin-top: 2px
      position: absolute

      .v-autocomplete-list-item
        position: relative
        cursor: pointer
        height: 30px
        line-height: 30px !important
        background-color: #fff
        padding-left: 12px
        font-size: 12px
        text-align: justify
        color: #8d99a2

        &:hover
          background-color: $reev-base-green
          &::before
            position: absolute
            content: " "
            right: 9px
            top: calc(50% - 3.5px)
            width: 7px
            height: 7px
            background-image: url('../../../assets/images/autocomplete-selection-arrow.svg')

  .datepicker
    .calendar
      border-radius: 0px
      background: #cccccc45
      border: 0px

  .has-error
    input
      border-color: #a94442 !important

.width-flow
  width: 900px

</style>



// WEBPACK FOOTER //
// meeting_modal.vue?577790a3